import React from 'react'

export default function PortfolioListItem({
    title,          // required - string - headline for card
    subtitle = "",       // optional - string - subtitle for card
    imageURL = "",       // optional - string - image url for card image
    imageAlt = "",       // optional - string - alternate text for the background image
    content = "",        // optional - string - card content
    type = "",           // optional - string - category for the type of card TBD (to be defined)
    date = "",           // optional - string - date subtitle for the card
    githubURL = "",      // optional - string - url for a project hosted on github
    deployedURL = "",    // optional - string - url for a project deployed (gh-pages, netlify, etc)
    icon = "",           // optional - string - icon for the card using fontawesome codes (bulma)
    selector = "",           // optional - string - css selector used for card specific styles
}) {
    // check if the icon is defined or not
    const headerIcon = (icon.trim() !== "")
        ? (
            <p className="card-header-icon" aria-label="see more">
                <span className="icon is-large">
                    <i className={icon} ></i>
                </span>
            </p>
        )
        : null
    // check if imageURL and imageAlt exist not as empty string and then
    // create the element and append it to the returned component. Card Image if it does
    // exist and card header if it does not
    const imageBackground = (imageURL.trim() !== "")
        ? <img src={imageURL} alt={imageAlt} className="card-image" />
        : null
    // append the image class to the selector value or keep it the same if we
    selector = (imageBackground) ? selector + ' has-image' : selector

    // check if a github url was supplied or not
    const githubLink = (githubURL.trim() !== "")
        ? <a className="button github animate-hover-bounce" href={githubURL} target="_blank">Github</a>
        : null
    // : <button className="button" disabled>Github</button>

    // check if a deployment link was suupplied or not
    const deploymentLink = (deployedURL.trim() !== "")
        ? <a className="button github animate-hover-bounce" href={deployedURL} target="_blank">Visit</a>
        : null
    // : <button className="button" disabled>Visit</button>

    // check if we have a type set
    const typeElement = (type.trim() !== "")
        ? <div className="subtitle muted">{type}</div>
        : null // empty element that does not add anything to DOM

    // if we have content lets grab all the text from <bullet></bullet> occurences in the content with li's
    // using the regex: /(?<=(<bullet>)).*?(?=(<\/bullet>))/ containing the positive lookbehind and ahead
    // then map through the content while replacing all occureneces of <bullet> or </bullet> with an empty string
    const exp = (navigator.userAgent.indexOf('Safari') === -1) // if we arent using safari
        ? new RegExp('(?<=(<bullet>)).*?(?=(</bullet>))', 'g')
        : new RegExp('(?=(<bullet>)).*?(?=(</bullet>))', 'g') //is supported in browsers like safari
    const bulletPoints = content.match(exp)?.map(val => val.replace(/<\/?bullet>/g, ''))

    const contentElements = (bulletPoints?.length > 0 || bulletPoints)
        ? <ul>{bulletPoints.map((bullet, idx) => <li key={`${title}-${idx}`}>{bullet}</li>)}</ul>
        : `${content}` // if we don't have any bullet tags just return the content text 


    // check if we have footer content otherwise do not render the footer
    const footer = (githubLink || deploymentLink)
        ? (
            <div className="card-footer is-flex is-flex-direction-row is-justify-content-center">
                <div className="buttons">
                    {githubLink}
                    {deploymentLink}
                </div>
            </div>
        )
        : null

    return (
        <div className={`card portfolio-li ${selector} notification is-info`}>
            {/* Card Image background */}
            {imageBackground}
            {/* Card Header */}
            <header className="card-header">
                <p className="card-header-title has-text-white has-text-centered">{title}</p>
                {headerIcon}
            </header>
            {/* Card Content */}
            <div className="card-content">
                <div className="subtitle">{subtitle}</div>
                <div className="content portfolio-content">
                    {contentElements}
                </div>
                <time>{date}</time>
                {typeElement}
            </div>
            {/* Card Footer */}
            {footer}
        </div>
    )
}
